import React from 'react';
import {
  Zap, GitCompare, Download, Search, Filter, Users,
  Shield, MessageCircle, Star, ExternalLink, ArrowRight
} from 'lucide-react';
import './ChatComponents.css';

const ICON_MAP = {
  'zap': Zap,
  'git-compare': GitCompare,
  'download': Download,
  'search': Search,
  'filter': Filter,
  'users': Users,
  'shield': Shield,
  'message-circle': MessageCircle,
  'star': Star,
  'external-link': ExternalLink,
  'arrow-right': ArrowRight,
};

/**
 * Suggested action chips for one-click follow-ups
 */
function ActionChips({ actions, onAction }) {
  if (!actions || actions.length === 0) return null;

  const handleClick = (action) => {
    if (action.query) {
      onAction({ type: 'query', query: action.query });
    } else if (action.action === 'open_url' && action.url) {
      window.open(action.url, '_blank', 'noopener');
    } else if (action.action === 'export_gap_analysis') {
      // Handle export
      const blob = new Blob([JSON.stringify(action.data, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `gap-analysis-${action.data?.framework || 'report'}.json`;
      a.click();
      URL.revokeObjectURL(url);
    } else if (action.action === 'show_search') {
      onAction({ type: 'focus_input', placeholder: action.placeholder, defaultValue: action.defaultValue });
    } else if (action.action === 'show_filter') {
      onAction({ type: 'show_filter', options: action.options });
    }
  };

  const getIcon = (iconName) => {
    const IconComponent = ICON_MAP[iconName] || ArrowRight;
    return <IconComponent size={14} />;
  };

  return (
    <div className="cc-action-chips">
      <span className="cc-chips-label">Quick actions:</span>
      <div className="cc-chips-row">
        {actions.map((action, idx) => (
          <button
            key={idx}
            className="cc-chip"
            onClick={() => handleClick(action)}
            title={action.query || action.label}
          >
            {action.icon && getIcon(action.icon)}
            <span>{action.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default ActionChips;
